import { render, staticRenderFns } from "./AdminElementsTable.vue?vue&type=template&id=4ce703bd&scoped=true"
import script from "./AdminElementsTable.vue?vue&type=script&lang=js"
export * from "./AdminElementsTable.vue?vue&type=script&lang=js"
import style0 from "./AdminElementsTable.vue?vue&type=style&index=0&id=4ce703bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce703bd",
  null
  
)

export default component.exports